// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IT32","select":"styles_select__26Fcp"};